<template>
  <div class="page">
    <c-source-form
      :columns="columns"
      :data="data"
      @submit="handleUpdate"
    />
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class CustompagesConfigShare extends Vue {

  data = {}

  get columns() {
    return [
      {
        prop: 'share_words',
        label: '分享语',
        form: {
          component: 'input'
        }
      },
      {
        prop: 'share_cover',
        label: '分享卡片图',
        form: {
          component: 'upload',
          props: {
            hint: '建议尺寸420:340'
          }
        }
      }
    ]
  }

  async mounted() {
    this.fetchData();
  }

  async fetchData() {
    const data = await this.$request.get(`/custom_pages/${this.$route.params.id}`);
    this.data = data.share_setting;
  }

  async handleUpdate(data) {
    const id = this.$route.params.id;
    await this.$autoLoading(
      this.$request.put(`/custom_pages/${id}`, { share_setting_attributes: data })
    );
    this.$message.success('更新成功');
    this.fetchData();
  }
}
</script>
